import React from "react";
import { Crown } from "lucide-react";

/**
 * GOLD badge — exclusive premium status indicator.
 * Shown next to user name in community chat, on profile pages, and admin lists
 * for users with `plan_tier="gold"`. Implements a gold gradient with a soft glow,
 * matching the Pricing page Gold card aesthetic.
 *
 * @param {object}  props
 * @param {"xs"|"sm"|"md"} [props.size="sm"]  Visual size variant.
 * @param {string} [props.label]  Optional override for tooltip/text label.
 */
export default function GoldBadge({ size = "sm", label = "PREMIUM GOLD · 1 rok plný PRO prístup" }) {
  const sizeMap = {
    xs: { box: "w-3.5 h-3.5", icon: "w-2 h-2" },
    sm: { box: "w-4 h-4", icon: "w-2.5 h-2.5" },
    md: { box: "w-5 h-5", icon: "w-3 h-3" },
  };
  const dim = sizeMap[size] || sizeMap.sm;
  return (
    <span
      data-testid="gold-badge"
      title={label}
      aria-label={label}
      className={`inline-flex items-center justify-center ${dim.box} bg-gradient-to-br from-amber-300 via-yellow-200 to-amber-500 rounded-full shadow-[0_0_8px_-1px_rgba(251,191,36,0.9)] ring-1 ring-amber-200/50 flex-shrink-0`}
    >
      <Crown className={`${dim.icon} text-amber-900`} strokeWidth={2.5} />
    </span>
  );
}
